var _path, _rect, _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorNewsagent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.454,3.15h31.092v30.326c0,2.968-2.406,5.374-5.374,5.374H5.454V3.15Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.786,
    y: 10.116,
    width: 6.224,
    height: 10.368
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.041,
    y1: 25.668,
    x2: 18.58,
    y2: 25.668
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.041,
    y1: 30.852,
    x2: 31.009,
    y2: 30.852
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 11.134,
    y1: 20.484,
    x2: 18.673,
    y2: 20.484
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 11.134,
    y1: 15.3,
    x2: 18.673,
    y2: 15.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 11.134,
    y1: 10.116,
    x2: 18.673,
    y2: 10.116
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 24.441,
    y1: 25.668,
    x2: 31.009,
    y2: 25.668
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorNewsagent);
export default __webpack_public_path__ + "static/media/indoor-newsagent.ba7d519fce523e5cfe6dfde6c7d1d078.svg";
export { ForwardRef as ReactComponent };